<template>
  <div class="page-wrapper" :class="{ 'desktop-layout': isDesktopView }">
    <!-- 通用提示 -->
    <transition name="slide-down">
      <div class="new-user-toast" v-if="showToast" @click="handleToastClick">
        <div class="toast-icon">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path fill="#4CAF50" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
          </svg>
        </div>
        <span class="toast-text">{{ toastMessage }}</span>
        <button class="toast-close" @click.stop="closeToast">×</button>
      </div>
    </transition>

    <!-- 公告弹窗 -->
    <AnnouncementPopup />

    <!-- 红包弹窗 -->
    <RedEnvelopePopup />

    <!-- ========== 桌面端左侧导航栏 ========== -->
    <div v-if="isDesktopView" class="desktop-sidebar-nav">
      <div class="nav-icon-item" :class="{ active: desktopActiveNav === 'home' }" @click="desktopActiveNav = 'home'" title="主页">
        <svg viewBox="0 0 1024 1024" width="22" height="22">
          <path d="M544 544m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" fill="currentColor"></path>
          <path d="M32 544m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" fill="currentColor"></path>
          <path d="M544 32m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" fill="currentColor"></path>
          <path d="M32 32m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" fill="currentColor"></path>
        </svg>
        <span class="nav-label">主页</span>
      </div>
      <div class="nav-icon-item" :class="{ active: desktopActiveNav === 'chat', disabled: isExpired || !canUseChat }" @click="!isExpired && canUseChat && (desktopActiveNav = 'chat')" title="聊天">
        <svg viewBox="0 0 1024 1024" width="22" height="22">
          <path d="M960 624h-256c-26.24 0-48-21.76-48-48s21.76-48 48-48h256c26.24 0 48 21.76 48 48s-21.76 48-48 48zM960 816h-256c-26.24 0-48-21.76-48-48s21.76-48 48-48h256c26.24 0 48 21.76 48 48s-21.76 48-48 48zM960 1008h-256c-26.24 0-48-21.76-48-48s21.76-48 48-48h256c26.24 0 48 21.76 48 48s-21.76 48-48 48z" fill="currentColor"></path>
          <path d="M620.16 864C593.28 840.32 576 806.4 576 768s17.28-72.32 44.16-96C593.28 648.32 576 614.4 576 576c0-30.72 11.52-58.88 29.44-81.28-19.84-7.68-39.68-14.72-60.8-19.84A239.808 239.808 0 0 0 448 15.36c-132.48 0-240 107.52-240 240 0 97.92 58.88 181.76 143.36 219.52C159.36 519.04 16 691.2 16 896c0 21.76 1.92 42.88 5.12 64 0 2.56 0 5.12 0.64 7.68 0 1.92 1.28 3.2 1.92 5.12 0.64 3.2 1.92 6.4 3.2 8.96 1.28 3.2 3.2 5.76 5.12 8.32 1.92 1.92 3.2 3.84 5.12 5.76 2.56 2.56 5.76 4.48 8.96 6.4a19.2 19.2 0 0 0 6.4 2.56c3.84 1.28 7.04 1.92 10.88 2.56 1.92 0 3.2 0.64 4.48 0.64h516.48c-5.76-14.72-9.6-30.72-9.6-48 0-38.4 17.28-72.32 44.16-96z" fill="currentColor"></path>
        </svg>
        <span class="nav-label">聊天</span>
      </div>
      <div class="nav-spacer"></div>
      <div class="nav-icon-item" @click="openSettingsPage" title="设置">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
        <span class="nav-label">设置</span>
      </div>
      <div class="nav-icon-item logout-nav" @click="logout" title="退出">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
        <span class="nav-label">退出</span>
      </div>
    </div>

    <!-- ========== 桌面端主内容区 ========== -->
    <div v-if="isDesktopView" class="desktop-main-area">
      <!-- 主页仪表盘（桌面端，切换到home时展示在第二栏） -->
      <div v-if="desktopActiveNav === 'home'" class="desktop-panel-second">
        <div class="desktop-home-panel">
          <div class="desktop-home-header">白菜台</div>
          <div class="desktop-home-scroll">
            <!-- 用户信息卡片 -->
            <div class="info-card">
              <div class="info-row">
                <span class="info-label">账号：</span>
                <span class="info-value">{{ account }}</span>
                <span v-if="!isGuest" class="admin-badge">主账号：拥有账号所有权</span>
                <span v-else class="guest-badge">访客</span>
              </div>
              <div class="info-row" @click="openRenewPage" style="cursor: pointer;">
                <span class="info-label">到期：</span>
                <span class="info-value">{{ expireDate }}</span>
                <span class="expire-days" :class="expireClass">{{ expireText }}</span>
                <span class="arrow">›</span>
              </div>
              <div class="info-row" @click="openRechargePage" style="cursor: pointer;">
                <span class="info-label">余额：</span>
                <span class="info-value">{{ balance }}元</span>
                <span class="refresh-hint">点击充值</span>
                <span class="arrow">›</span>
              </div>
            </div>
            <!-- TG频道提示 -->
            <div class="tg-notice">
              <div class="tg-title">{{ tgTitle }}</div>
              <div class="tg-desc">{{ tgDesc1 }}</div>
              <div class="tg-desc">{{ tgDesc2 }}</div>
            </div>
            <!-- 功能按钮 -->
            <div class="feature-grid">
              <div class="feature-item" :class="{ 'disabled-feature': isExpired }" @click="!isExpired && openSharePage()">
                <div class="feature-icon">
                  <svg viewBox="0 0 1024 1024" width="24" height="24">
                    <path d="M24 21.94h976v976H24z" fill="#EBEBEB"></path>
                    <path d="M395.648 394.172H156.896V155.42h238.752v238.752z m-158.752-80h78.752V235.42H236.896v78.752zM869.072 394.172H630.32V155.42h238.752v238.752z m-158.752-80h78.752V235.42H710.32v78.752zM395.648 870.428H156.896V631.68h238.752v238.748z m-158.752-80h78.752V711.68H236.896v78.748zM585.584 354.172h-80V235.42h-62.056v-80h142.056zM236.896 583.8h-80v-142.056h150.56v80.004h-70.56zM404.264 418.492h80v158.752h-80zM710.32 667.468h-80v-118.756h-62.064v-80h142.064zM780.572 469.024h80v194.152h-80zM435.024 631.68h155.916v80h-155.916zM635.196 871.852H436.44v-80h118.756v-62.056h80zM781.192 867.28h-80v-142.044h164.728v80h-84.728z" fill="#666666"></path>
                  </svg>
                </div>
                <span class="feature-text">分享页</span>
              </div>
              <div class="feature-item" :class="{ 'disabled-feature': isExpired }" @click="!isExpired && openFukuantu()">
                <div class="feature-icon">
                  <svg viewBox="0 0 1024 1024" width="24" height="24">
                    <path d="M913.511491 913.927599c0 60.537454-49.534948 110.067667-110.067667 110.067667H220.542995C160.005541 1023.995266 110.475327 974.465052 110.475327 913.927599V110.067667C110.475327 49.530214 160.005541 0 220.542995 0h582.905563c60.532719 0 110.067667 49.530214 110.067667 110.067667l-0.004734 803.859932z" fill="#EDEDED"></path>
                    <path d="M255.993409 186.302903h517.38763v47.342969H255.993409zM255.993409 341.461159h377.257178v47.342969H255.993409zM255.993409 496.414695h517.38763v47.342968H255.993409zM255.993409 651.363496h447.324771v47.342968H255.993409zM255.993409 806.307563h188.633323v47.342968H255.993409z" fill="#00CCC6"></path>
                  </svg>
                </div>
                <span class="feature-text">付款图</span>
              </div>
              <div class="feature-item" :class="{ 'disabled-feature': isExpired }" @click="!isExpired && openPaymentPage()">
                <div class="feature-icon">
                  <svg viewBox="0 0 1024 1024" width="24" height="24">
                    <path d="M962.45708 400.932164c0 24.077322-19.697958 43.775279-43.775279 43.775279H107.76036c-24.077322 0-43.770689-19.697958-43.770689-43.775279V43.775279C63.989671 19.697958 83.683038 0 107.76036 0H918.681801c24.077322 0 43.775279 19.697958 43.775279 43.775279v357.156885z" fill="#00CCC6"></path>
                    <path d="M60.666129 156.302903h902.667742v867.697097H60.666129z" fill="#F5F5F5"></path>
                    <path d="M141.98275 77.336633m-26.423082 0a26.423082 26.423082 0 1 0 52.846163 0 26.423082 26.423082 0 1 0-52.846163 0Z" fill="#FF8097"></path>
                    <path d="M230.68094 77.336633m-26.423081 0a26.423082 26.423082 0 1 0 52.846163 0 26.423082 26.423082 0 1 0-52.846163 0Z" fill="#FFCB8F"></path>
                    <path d="M325.672746 77.336633m-26.423082 0a26.423082 26.423082 0 1 0 52.846163 0 26.423082 26.423082 0 1 0-52.846163 0Z" fill="#9AE3B0"></path>
                    <path d="M623.32261 621.291301v39.395915h204.278516v-39.395915h-204.278516z m0 138.620188h116.732548v-39.395915h-116.732548v39.395915z" fill="#B2B2B2" opacity=".27"></path>
                    <path d="M826.136748 895.846217c0 22.870013-19.693367 41.585597-43.770689 41.585598h-115.26817c-24.072731 0-43.770689-18.710994-43.770688-41.585598s19.697958-41.585597 43.770688-41.585597h115.26817c24.072731 0 43.770689 18.710994 43.770689 41.585597z" fill="#FF7D7D"></path>
                    <path d="M405.226604 621.089318c0 17.402693-30.522424 39.827425-68.169348 39.827425-37.656105 0-68.169347-22.424731-68.169347-39.827425l-4.59971-0.449872H233.958578l-90.897054 90.897054 58.666953 60.342497 32.230101-32.22551v197.773737h207.826994v-197.782918l30.820808 30.825398 58.662363-60.342496-87.8214-89.478581h-33.409866l-4.810873 0.440691z" fill="#B2B2B2" opacity=".27"></path>
                    <path d="M146.206036 242.664515h722.241612v249.504402H146.206036z" fill="#00CCC6" opacity=".46"></path>
                  </svg>
                </div>
                <span class="feature-text">付款页</span>
              </div>
              <div class="feature-item" :class="{ 'disabled-feature': isExpired }" @click="!isExpired && openFengkongtu()">
                <div class="feature-icon">
                  <svg viewBox="0 0 1024 1024" width="24" height="24">
                    <path d="M992.0512 256c-7.0656 196.096-46.523733 354.9184-118.3744 476.433067-82.978133 140.322133-203.1616 237.397333-360.516267 291.191466V1024a3.345067 3.345067 0 0 0-0.546133-0.170667 3.345067 3.345067 0 0 1-0.546133 0.170667v-0.375467c-157.3888-53.794133-277.538133-150.869333-360.516267-291.191466C79.633067 610.9184 40.174933 452.096 33.109333 256a96.119467 96.119467 0 0 0 90.385067-125.815467L512 0.375467V0l0.546133 0.170667 0.580267-0.170667v0.375467l388.5056 129.809066A96.119467 96.119467 0 0 0 992.0512 256z" fill="#D0D6FE"></path>
                    <path d="M512 102.673067V102.4v0.273067L512.853333 102.4v808.686933L512 910.779733v0.3072-0.3072c-123.0848-42.496-217.122133-119.159467-282.0096-229.9904-56.2176-95.9488-87.074133-221.354667-92.603733-376.2176a75.537067 75.537067 0 0 0 74.410666-75.810133c0-8.226133-1.297067-16.145067-3.720533-23.552L512 102.673067z" fill="#8493DC"></path>
                  </svg>
                </div>
                <span class="feature-text">风控图</span>
              </div>
              <div class="feature-item" @click="openSettingsPage">
                <div class="feature-icon">
                  <svg viewBox="0 0 1024 1024" width="24" height="24">
                    <path d="M512.002132 512.002132m-130.775205 0a130.775205 130.775205 0 1 0 261.55041 0 130.775205 130.775205 0 1 0-261.55041 0Z" fill="#F06262"></path>
                    <path d="M512.002132 674.755885c-89.740333 0-162.753753-73.01342-162.753753-162.753753S422.261799 349.248379 512.002132 349.248379s162.753753 73.01342 162.753753 162.753753-73.01342 162.753753-162.753753 162.753753z m0-261.55041c-54.47439 0-98.796657 44.322267-98.796657 98.796657 0 54.478654 44.322267 98.796657 98.796657 98.796657 54.478654 0 98.796657-44.322267 98.796657-98.796657S566.480786 413.205475 512.002132 413.205475z" fill="#B34848"></path>
                    <path d="M1024 565.299711v-106.595159h-104.663655a413.141518 413.141518 0 0 0-27.902349-104.224482l90.618677-52.316904-53.29758-92.311408-90.337265 52.154879a420.863271 420.863271 0 0 0-75.968238-77.187686l51.711444-89.569781-92.307144-53.297579-51.042026 88.405761a413.576426 413.576426 0 0 0-105.512153-29.791215V0h-106.595159v98.984265a413.900475 413.900475 0 0 0-107.904147 27.22014L302.154638 41.947327l-92.315672 53.29758 47.946503 83.046156a420.552013 420.552013 0 0 0-80.756493 78.778086L95.240643 209.847494l-53.29758 92.315672 80.701063 46.590612a413.576426 413.576426 0 0 0-30.315663 109.959302H0v106.595159h91.966039a413.665966 413.665966 0 0 0 29.701676 110.526389l-79.720388 46.00647 53.293316 92.311408 80.304529-46.351839a420.701246 420.701246 0 0 0 81.106124 79.873885l-46.808066 81.076278 92.311408 53.297579 47.336778-81.988732a414.028389 414.028389 0 0 0 109.213136 27.753115v96.182944h106.595159v-97.764816a413.887684 413.887684 0 0 0 106.795558-30.354037l49.750093 86.171526 92.307144-53.297579-50.594326-87.64254a420.326031 420.326031 0 0 0 76.339189-78.257902l88.866252 51.29359 53.284788-92.315671-89.69343-51.779665a413.43572 413.43572 0 0 0 27.335262-104.757458h104.309759v0.008527z m-518.167596 258.599856c-171.208881 0-310.498907-139.290026-310.498907-310.498907s139.285762-310.498907 310.498907-310.498907c171.208881 0 310.498907 139.290026 310.498907 310.498907s-139.290026 310.498907-310.498907 310.498907z" fill="#F06262"></path>
                  </svg>
                </div>
                <span class="feature-text">设置</span>
              </div>
              <div class="feature-item logout-item" @click="logout">
                <div class="feature-icon">
                  <svg viewBox="0 0 1182 1024" width="24" height="24">
                    <path d="M295.598598 1024L0 512.002621 295.598598 0h591.207677L1182.415355 512.002621l-295.60908 511.997379z" fill="#F78383"></path>
                    <path d="M591.207678 590.542045c-28.947163 0-52.412028-23.470106-52.412029-52.412028V228.044734c0-28.947163 23.464865-52.412028 52.412029-52.412028 28.941922 0 52.412028 23.464865 52.412028 52.412028v310.085283c0 28.941922-23.464865 52.412028-52.412028 52.412028zM591.207678 809.131649c-28.947163 0-52.412028-23.470106-52.412029-52.412028V700.801228c0-28.941922 23.464865-52.412028 52.412029-52.412028 28.941922 0 52.412028 23.470106 52.412028 52.412028v55.918393c0 28.941922-23.464865 52.412028-52.412028 52.412028z" fill="#FFFFFF"></path>
                  </svg>
                </div>
                <span class="feature-text">退出</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 主页时右侧占位 -->
        <div class="desktop-panel-chat-placeholder">
          <div class="placeholder-content">
            <svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="#ccc" stroke-width="1">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"></path>
            </svg>
            <p>切换到「聊天」开始对话</p>
          </div>
        </div>
      </div>

      <!-- 聊天模式：ChatPage 占满整个主内容区（列表+详情+话术并排） -->
      <div v-else class="desktop-chat-full">
        <ChatPage ref="chatPageDesktop" :desktopMode="true" />
      </div>
    </div>

    <!-- ========== 移动端原有布局 ========== -->
    <!-- 主内容区域（移动端） -->
    <template v-if="!isDesktopView">
    <transition :name="transitionName" @before-leave="onBeforeLeave" @after-enter="onAfterEnter">
      <div class="main-content" v-if="activeTab === 'home'" key="home">
        <div class="content">
          <!-- 顶部标题 -->
          <div class="page-title" v-fade-down>白菜台</div>

          <!-- 用户信息卡片 -->
          <div class="info-card" v-motion="{ initial: { opacity: 0, y: 18, scale: 0.98 }, animate: { opacity: 1, y: 0, scale: 1 }, transition: { type: 'spring', stiffness: 260, damping: 24, delay: 0.06 } }">
            <div class="info-row">
              <span class="info-label">账号：</span>
              <span class="info-value">{{ account }}</span>
              <span v-if="!isGuest" class="admin-badge">主账号：拥有账号所有权</span>
              <span v-else class="guest-badge">访客</span>
              <span class="arrow">›</span>
            </div>
            <div class="info-row" @click="openRenewPage" style="cursor: pointer;">
              <span class="info-label">到期：</span>
              <span class="info-value">{{ expireDate }}</span>
              <span class="expire-days" :class="expireClass">{{ expireText }}</span>
              <span class="arrow">›</span>
            </div>
            <div class="info-row" @click="openRechargePage" style="cursor: pointer;">
              <span class="info-label">余额：</span>
              <span class="info-value">{{ balance }}元</span>
              <span class="refresh-hint">点击充值</span>
              <span class="arrow">›</span>
            </div>
          </div>

          <!-- TG频道提示 -->
          <div class="tg-notice" v-motion="{ initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { type: 'spring', stiffness: 240, damping: 22, delay: 0.14 } }">
            <div class="tg-title">{{ tgTitle }}</div>
            <div class="tg-desc">{{ tgDesc1 }}</div>
            <div class="tg-desc">{{ tgDesc2 }}</div>
          </div>

          <!-- 功能按钮网格 -->
          <div class="feature-grid" v-motion="{ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { type: 'spring', stiffness: 220, damping: 22, delay: 0.22 } }">
            <div class="feature-item" :class="{ 'disabled-feature': isExpired }" @click="!isExpired && openSharePage()">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M24 21.94h976v976H24z" fill="#EBEBEB"></path>
                  <path d="M395.648 394.172H156.896V155.42h238.752v238.752z m-158.752-80h78.752V235.42H236.896v78.752zM869.072 394.172H630.32V155.42h238.752v238.752z m-158.752-80h78.752V235.42H710.32v78.752zM395.648 870.428H156.896V631.68h238.752v238.748z m-158.752-80h78.752V711.68H236.896v78.748zM585.584 354.172h-80V235.42h-62.056v-80h142.056zM236.896 583.8h-80v-142.056h150.56v80.004h-70.56zM404.264 418.492h80v158.752h-80zM710.32 667.468h-80v-118.756h-62.064v-80h142.064zM780.572 469.024h80v194.152h-80zM435.024 631.68h155.916v80h-155.916zM635.196 871.852H436.44v-80h118.756v-62.056h80zM781.192 867.28h-80v-142.044h164.728v80h-84.728z" fill="#666666"></path>
                </svg>
              </div>
              <span class="feature-text">分享页</span>
            </div>

            <div class="feature-item" :class="{ 'disabled-feature': isExpired }" @click="!isExpired && openFukuantu()">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M913.511491 913.927599c0 60.537454-49.534948 110.067667-110.067667 110.067667H220.542995C160.005541 1023.995266 110.475327 974.465052 110.475327 913.927599V110.067667C110.475327 49.530214 160.005541 0 220.542995 0h582.905563c60.532719 0 110.067667 49.530214 110.067667 110.067667l-0.004734 803.859932z" fill="#EDEDED"></path>
                  <path d="M255.993409 186.302903h517.38763v47.342969H255.993409zM255.993409 341.461159h377.257178v47.342969H255.993409zM255.993409 496.414695h517.38763v47.342968H255.993409zM255.993409 651.363496h447.324771v47.342968H255.993409zM255.993409 806.307563h188.633323v47.342968H255.993409z" fill="#00CCC6"></path>
                </svg>
              </div>
              <span class="feature-text">付款图</span>
            </div>

            <div class="feature-item" :class="{ 'disabled-feature': isExpired }" @click="!isExpired && openPaymentPage()">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M962.45708 400.932164c0 24.077322-19.697958 43.775279-43.775279 43.775279H107.76036c-24.077322 0-43.770689-19.697958-43.770689-43.775279V43.775279C63.989671 19.697958 83.683038 0 107.76036 0H918.681801c24.077322 0 43.775279 19.697958 43.775279 43.775279v357.156885z" fill="#00CCC6"></path>
                  <path d="M60.666129 156.302903h902.667742v867.697097H60.666129z" fill="#F5F5F5"></path>
                  <path d="M141.98275 77.336633m-26.423082 0a26.423082 26.423082 0 1 0 52.846163 0 26.423082 26.423082 0 1 0-52.846163 0Z" fill="#FF8097"></path>
                  <path d="M230.68094 77.336633m-26.423081 0a26.423082 26.423082 0 1 0 52.846163 0 26.423082 26.423082 0 1 0-52.846163 0Z" fill="#FFCB8F"></path>
                  <path d="M325.672746 77.336633m-26.423082 0a26.423082 26.423082 0 1 0 52.846163 0 26.423082 26.423082 0 1 0-52.846163 0Z" fill="#9AE3B0"></path>
                  <path d="M623.32261 621.291301v39.395915h204.278516v-39.395915h-204.278516z m0 138.620188h116.732548v-39.395915h-116.732548v39.395915z" fill="#B2B2B2" opacity=".27"></path>
                  <path d="M826.136748 895.846217c0 22.870013-19.693367 41.585597-43.770689 41.585598h-115.26817c-24.072731 0-43.770689-18.710994-43.770688-41.585598s19.697958-41.585597 43.770688-41.585597h115.26817c24.072731 0 43.770689 18.710994 43.770689 41.585597z" fill="#FF7D7D"></path>
                  <path d="M405.226604 621.089318c0 17.402693-30.522424 39.827425-68.169348 39.827425-37.656105 0-68.169347-22.424731-68.169347-39.827425l-4.59971-0.449872H233.958578l-90.897054 90.897054 58.666953 60.342497 32.230101-32.22551v197.773737h207.826994v-197.782918l30.820808 30.825398 58.662363-60.342496-87.8214-89.478581h-33.409866l-4.810873 0.440691z" fill="#B2B2B2" opacity=".27"></path>
                  <path d="M146.206036 242.664515h722.241612v249.504402H146.206036z" fill="#00CCC6" opacity=".46"></path>
                </svg>
              </div>
              <span class="feature-text">付款页</span>
            </div>

            <div class="feature-item" :class="{ 'disabled-feature': isExpired }" @click="!isExpired && openFengkongtu()">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M992.0512 256c-7.0656 196.096-46.523733 354.9184-118.3744 476.433067-82.978133 140.322133-203.1616 237.397333-360.516267 291.191466V1024a3.345067 3.345067 0 0 0-0.546133-0.170667 3.345067 3.345067 0 0 1-0.546133 0.170667v-0.375467c-157.3888-53.794133-277.538133-150.869333-360.516267-291.191466C79.633067 610.9184 40.174933 452.096 33.109333 256a96.119467 96.119467 0 0 0 90.385067-125.815467L512 0.375467V0l0.546133 0.170667 0.580267-0.170667v0.375467l388.5056 129.809066A96.119467 96.119467 0 0 0 992.0512 256z" fill="#D0D6FE"></path>
                  <path d="M512 102.673067V102.4v0.273067L512.853333 102.4v808.686933L512 910.779733v0.3072-0.3072c-123.0848-42.496-217.122133-119.159467-282.0096-229.9904-56.2176-95.9488-87.074133-221.354667-92.603733-376.2176a75.537067 75.537067 0 0 0 74.410666-75.810133c0-8.226133-1.297067-16.145067-3.720533-23.552L512 102.673067z" fill="#8493DC"></path>
                </svg>
              </div>
              <span class="feature-text">风控图</span>
            </div>

            <div class="feature-item" @click="openSettingsPage">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M512.002132 512.002132m-130.775205 0a130.775205 130.775205 0 1 0 261.55041 0 130.775205 130.775205 0 1 0-261.55041 0Z" fill="#F06262"></path>
                  <path d="M512.002132 674.755885c-89.740333 0-162.753753-73.01342-162.753753-162.753753S422.261799 349.248379 512.002132 349.248379s162.753753 73.01342 162.753753 162.753753-73.01342 162.753753-162.753753 162.753753z m0-261.55041c-54.47439 0-98.796657 44.322267-98.796657 98.796657 0 54.478654 44.322267 98.796657 98.796657 98.796657 54.478654 0 98.796657-44.322267 98.796657-98.796657S566.480786 413.205475 512.002132 413.205475z" fill="#B34848"></path>
                  <path d="M1024 565.299711v-106.595159h-104.663655a413.141518 413.141518 0 0 0-27.902349-104.224482l90.618677-52.316904-53.29758-92.311408-90.337265 52.154879a420.863271 420.863271 0 0 0-75.968238-77.187686l51.711444-89.569781-92.307144-53.297579-51.042026 88.405761a413.576426 413.576426 0 0 0-105.512153-29.791215V0h-106.595159v98.984265a413.900475 413.900475 0 0 0-107.904147 27.22014L302.154638 41.947327l-92.315672 53.29758 47.946503 83.046156a420.552013 420.552013 0 0 0-80.756493 78.778086L95.240643 209.847494l-53.29758 92.315672 80.701063 46.590612a413.576426 413.576426 0 0 0-30.315663 109.959302H0v106.595159h91.966039a413.665966 413.665966 0 0 0 29.701676 110.526389l-79.720388 46.00647 53.293316 92.311408 80.304529-46.351839a420.701246 420.701246 0 0 0 81.106124 79.873885l-46.808066 81.076278 92.311408 53.297579 47.336778-81.988732a414.028389 414.028389 0 0 0 109.213136 27.753115v96.182944h106.595159v-97.764816a413.887684 413.887684 0 0 0 106.795558-30.354037l49.750093 86.171526 92.307144-53.297579-50.594326-87.64254a420.326031 420.326031 0 0 0 76.339189-78.257902l88.866252 51.29359 53.284788-92.315671-89.69343-51.779665a413.43572 413.43572 0 0 0 27.335262-104.757458h104.309759v0.008527z m-518.167596 258.599856c-171.208881 0-310.498907-139.290026-310.498907-310.498907s139.285762-310.498907 310.498907-310.498907c171.208881 0 310.498907 139.290026 310.498907 310.498907s-139.290026 310.498907-310.498907 310.498907z" fill="#F06262"></path>
                </svg>
              </div>
              <span class="feature-text">设置</span>
            </div>

            <div class="feature-item logout-item" @click="logout">
              <div class="feature-icon">
                <svg viewBox="0 0 1182 1024" width="24" height="24">
                  <path d="M295.598598 1024L0 512.002621 295.598598 0h591.207677L1182.415355 512.002621l-295.60908 511.997379z" fill="#F78383"></path>
                  <path d="M591.207678 590.542045c-28.947163 0-52.412028-23.470106-52.412029-52.412028V228.044734c0-28.947163 23.464865-52.412028 52.412029-52.412028 28.941922 0 52.412028 23.464865 52.412028 52.412028v310.085283c0 28.941922-23.464865 52.412028-52.412028 52.412028zM591.207678 809.131649c-28.947163 0-52.412028-23.470106-52.412029-52.412028V700.801228c0-28.941922 23.464865-52.412028 52.412029-52.412028 28.941922 0 52.412028 23.470106 52.412028 52.412028v55.918393c0 28.941922-23.464865 52.412028-52.412028 52.412028z" fill="#FFFFFF"></path>
                </svg>
              </div>
              <span class="feature-text">退出</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 聊天内容区域 -->
      <div class="main-content chat-content" v-else-if="activeTab === 'chat'" key="chat">
        <ChatPage ref="chatPage" />
      </div>
    </transition>
    </template>

    <!-- 底部导航（仅移动端） -->
    <div class="custom-tabbar" v-if="!isDesktopView">
      <div class="tab-item" :class="{ active: activeTab === 'home' }" @click="switchTab('home')">
        <svg viewBox="0 0 1024 1024" width="24" height="24">
          <path d="M544 544m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" :fill="activeTab === 'home' ? '#007AFF' : '#707070'"></path>
          <path d="M32 544m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" :fill="activeTab === 'home' ? '#007AFF' : '#707070'"></path>
          <path d="M544 32m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" :fill="activeTab === 'home' ? '#007AFF' : '#707070'"></path>
          <path d="M32 32m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" :fill="activeTab === 'home' ? '#007AFF' : '#707070'"></path>
        </svg>
        <span class="tab-text">主页</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'chat', disabled: isExpired || !canUseChat }" @click="switchTab('chat')">
        <svg viewBox="0 0 1024 1024" width="24" height="24">
          <path d="M960 624h-256c-26.24 0-48-21.76-48-48s21.76-48 48-48h256c26.24 0 48 21.76 48 48s-21.76 48-48 48zM960 816h-256c-26.24 0-48-21.76-48-48s21.76-48 48-48h256c26.24 0 48 21.76 48 48s-21.76 48-48 48zM960 1008h-256c-26.24 0-48-21.76-48-48s21.76-48 48-48h256c26.24 0 48 21.76 48 48s-21.76 48-48 48z" :fill="activeTab === 'chat' ? '#007AFF' : '#707070'"></path>
          <path d="M620.16 864C593.28 840.32 576 806.4 576 768s17.28-72.32 44.16-96C593.28 648.32 576 614.4 576 576c0-30.72 11.52-58.88 29.44-81.28-19.84-7.68-39.68-14.72-60.8-19.84A239.808 239.808 0 0 0 448 15.36c-132.48 0-240 107.52-240 240 0 97.92 58.88 181.76 143.36 219.52C159.36 519.04 16 691.2 16 896c0 21.76 1.92 42.88 5.12 64 0 2.56 0 5.12 0.64 7.68 0 1.92 1.28 3.2 1.92 5.12 0.64 3.2 1.92 6.4 3.2 8.96 1.28 3.2 3.2 5.76 5.12 8.32 1.92 1.92 3.2 3.84 5.12 5.76 2.56 2.56 5.76 4.48 8.96 6.4a19.2 19.2 0 0 0 6.4 2.56c3.84 1.28 7.04 1.92 10.88 2.56 1.92 0 3.2 0.64 4.48 0.64h516.48c-5.76-14.72-9.6-30.72-9.6-48 0-38.4 17.28-72.32 44.16-96z" :fill="activeTab === 'chat' ? '#007AFF' : '#707070'"></path>
        </svg>
        <span class="tab-text">聊天</span>
      </div>
    </div>

    <!-- 分享页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showSharePage">
      <SharePage @close="closeSharePage" @copy-success="showCopyToast('链接已复制')" />
    </div>

    <!-- 续费页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showXufeiPage">
      <XufeiPage @close="showXufeiPage = false" />
    </div>

    <!-- 风控图页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showFengkongtuPage">
      <FengkongtuPage @close="showFengkongtuPage = false" />
    </div>

    <!-- 付款图页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showFukuantuPage">
      <FukuantuPage @close="showFukuantuPage = false" />
    </div>

    <!-- 设置页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showSettingsPage">
      <SettingsPage @close="showSettingsPage = false" />
    </div>

    <!-- 付款页管理全屏弹窗 -->
    <div class="share-page-overlay" v-if="showPaymentPage">
      <PaymentPage @close="showPaymentPage = false" @copy-success="showCopyToast('已复制')" />
    </div>

    <!-- 充值页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showRechargePage">
      <RechargePage :currentBalance="balance" @close="closeRechargePage" />
    </div>

    <!-- 续费页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showRenewPage">
      <RenewPage @close="closeRenewPage" @go-recharge="goToRechargeFromRenew" />
    </div>
  </div>
</template>

<script>
import ChatPage from '../chat/chat.vue'
import SharePage from '../share/SharePage.vue'
import XufeiPage from './Xufei.vue'
import FengkongtuPage from './Fengkongtu.vue'
import FukuantuPage from './Fukuantu.vue'
import SettingsPage from './Settings.vue'
import PaymentPage from './PaymentPage.vue'
import RechargePage from './RechargePage.vue'
import RenewPage from './RenewPage.vue'
import AnnouncementPopup from '@/components/AnnouncementPopup.vue'
import RedEnvelopePopup from '@/components/RedEnvelopePopup.vue'
import { getCurrentUser } from '@/api/auth.js'
import { apiFetch } from '@/config/api'
import { responsiveMixin } from '@/composables/useResponsive'

export default {
  name: 'HomePage',
  mixins: [responsiveMixin],
  components: {
    ChatPage,
    SharePage,
    XufeiPage,
    FengkongtuPage,
    FukuantuPage,
    SettingsPage,
    PaymentPage,
    RechargePage,
    RenewPage,
    AnnouncementPopup,
    RedEnvelopePopup
  },
  data() {
    return {
      account: '示例账号',
      role: 'user',
      expireDays: 0,
      expireDate: '',
      isExpired: false,
      canUseChat: true,
      isGuest: false,
      hasGuestPassword: false,
      guestCanSpend: true,
      guestCanRecharge: true,
      balance: '0.00',
      tgChannel: '@lingshentop',
      tgTitle: process.env.VUE_APP_TG_TITLE || 'TG频道 @lingshentop 飞机 @baicainb886',
      tgDesc1: process.env.VUE_APP_TG_DESC1 || '请联系唯一飞机购买，不在我本人这里购买的无售后',
      tgDesc2: process.env.VUE_APP_TG_DESC2 || '源码均为白菜制作无售卖，具体看白菜频道 @lingshentop',
      activeTab: 'home',
      transitionName: 'slide-left',
      showSharePage: false,
      showXufeiPage: false,
      showFengkongtuPage: false,
      showFukuantuPage: false,
      showSettingsPage: false,
      showPaymentPage: false,
      showRechargePage: false,
      showRenewPage: false,
      // 通用提示相关
      showToast: false,
      toastMessage: '',
      toastType: 'newUser', // 'newUser' | 'copy' | 'info'
      knownSessionKeys: new Set(),
      sessionPollingInterval: null,
      toastTimeout: null,
      // 保存首页滚动位置
      homeScrollPosition: 0,
      // 桌面端导航
      desktopActiveNav: 'chat'
    }
  },
  computed: {
    isDesktopView() {
      return !this.isMobile && this.screenWidth >= 1024
    },
    expireText() {
      if (this.role === 'admin') return '永久'
      if (this.expireDays > 0) return `${this.expireDays} 天`
      if (this.expireDays === 0) return '今天到期'
      return `已过期${Math.abs(this.expireDays)}天`
    },
    expireClass() {
      if (this.role === 'admin') return 'expire-normal'
      if (this.expireDays < 0) return 'expire-expired'
      if (this.expireDays <= 3) return 'expire-critical'
      if (this.expireDays <= 7) return 'expire-warning'
      return 'expire-normal'
    }
  },
  provide() {
    return {
      showCopyToast: (message) => this.showCopyToast(message),
      showInfoToast: (message, duration) => this.showInfoToast(message, duration)
    }
  },
  mounted() {
    // 根据URL恢复页面状态（无刷新切换）
    this.restoreViewFromPath()

    // 检查登录状态
    this.checkLoginStatus()

    this.loadUserInfo()
    // 立即从后端获取最新数据（包括余额），完成后启动会话轮询
    this.refreshUserInfo().then(() => {
      // 启动会话轮询，检测新用户（仅未过期用户）
      this.startSessionPolling()
    })
    // 每10秒刷新一次用户信息（包括余额）
    this.updateTimer = setInterval(() => {
      this.refreshUserInfo()
    }, 10000)

    // 初始化历史状态，用于处理安卓返回键
    this.initHistoryState()
    // 监听浏览器返回事件
    window.addEventListener('popstate', this.handlePopState)
  },
  beforeUnmount() {
    if (this.updateTimer) clearInterval(this.updateTimer)
    if (this.sessionPollingInterval) clearInterval(this.sessionPollingInterval)
    if (this.toastTimeout) clearTimeout(this.toastTimeout)
    // 移除返回事件监听
    window.removeEventListener('popstate', this.handlePopState)
  },
  methods: {
    // 检查登录状态
    checkLoginStatus() {
      const token = localStorage.getItem('token')
      const user = localStorage.getItem('user')

      // 如果没有 token 或用户信息，跳转到登录页
      if (!token || !user) {
        console.log('未检测到登录信息，跳转到登录页')
        this.redirectToLogin()
        return
      }

      // 验证 token 格式（简单检查）
      if (token.length < 10) {
        console.log('Token 格式无效，跳转到登录页')
        this.redirectToLogin()
        return
      }

      console.log('登录状态检查通过')
    },

    // 跳转到登录页
    redirectToLogin() {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('username')
      window.location.href = '/'
      window.location.reload()
    },

    loadUserInfo() {
      try {
        const stored = localStorage.getItem('user')
        if (!stored) {
          window.location.href = '/'
          return
        }
        const data = JSON.parse(stored)
        this.updateUserData(data)
      } catch (e) {
        console.error('获取用户信息失败', e)
      }
    },
    async refreshUserInfo() {
      try {
        const res = await getCurrentUser()
        if (res && res.code === 0 && res.data) {
          this.updateUserData(res.data)
          const stored = localStorage.getItem('user')
          if (stored) {
            const userData = JSON.parse(stored)
            userData.expireDays = res.data.expireDays
            userData.role = res.data.role
            userData.isGuest = res.data.isGuest
            userData.hasGuestPassword = res.data.hasGuestPassword
            userData.balance = res.data.balance
            userData.guestCanSpend = res.data.guestCanSpend
            userData.guestCanRecharge = res.data.guestCanRecharge
            if (res.data.uid) userData.uid = res.data.uid
            localStorage.setItem('user', JSON.stringify(userData))
          }
        } else if (res && res.code === 401) {
          // Token 失效，跳转到登录页
          console.log('Token 已失效，跳转到登录页')
          this.redirectToLogin()
        }
      } catch (e) {
        console.error('刷新用户信息失败', e)
        // 如果是认证错误，跳转到登录页
        if (e.message && e.message.includes('登录')) {
          this.redirectToLogin()
        }
      }
    },
    updateUserData(data) {
      this.account = data.account || this.account
      this.role = data.role || 'user'
      this.isGuest = data.isGuest || false
      this.hasGuestPassword = data.hasGuestPassword || false
      this.guestCanSpend = data.guestCanSpend !== false
      this.guestCanRecharge = data.guestCanRecharge !== false
      // 更新余额
      if (data.balance !== undefined && data.balance !== null) {
        this.balance = parseFloat(data.balance).toFixed(2)
      }
      if (typeof data.expireDays === 'number') {
        this.expireDays = data.expireDays
        this.isExpired = data.isExpired || (this.expireDays < 0 && this.role !== 'admin')
        this.canUseChat = data.canUseChat !== undefined ? data.canUseChat : (this.role === 'admin' || this.expireDays >= 0)
        // 计算到期日期
        const now = new Date()
        now.setDate(now.getDate() + this.expireDays)
        const y = now.getFullYear()
        const m = String(now.getMonth() + 1).padStart(2, '0')
        const d = String(now.getDate()).padStart(2, '0')
        const h = String(now.getHours()).padStart(2, '0')
        const min = String(now.getMinutes()).padStart(2, '0')
        this.expireDate = `${y}-${m}-${d} ${h}:${min}`
      }
    },
    navigateTo(path) {
      if (this.isExpired) {
        alert('账号已过期，请先充值续费')
        return
      }
      alert(`跳转到: ${path} (功能开发中)`)
    },
    switchTab(tab) {
      if (tab === this.activeTab) return

      // 如果从首页切换出去，保存滚动位置
      if (this.activeTab === 'home') {
        const homeContent = this.$el.querySelector('.main-content[key="home"]')
        if (homeContent) {
          this.homeScrollPosition = homeContent.scrollTop
          console.log('保存首页滚动位置:', this.homeScrollPosition)
        }
      }

      this.transitionName = this.activeTab === 'home' && tab === 'chat' ? 'slide-left' : 'slide-right'
      this.activeTab = tab
      this.syncTabUrl(tab)

      // 如果切换到首页，恢复滚动位置
      if (tab === 'home') {
        this.$nextTick(() => {
          const homeContent = this.$el.querySelector('.main-content')
          if (homeContent) {
            homeContent.scrollTop = this.homeScrollPosition
            console.log('恢复首页滚动位置:', this.homeScrollPosition)
          }
        })
      }

      // 切换到聊天tab时添加历史状态
      if (tab === 'chat') {
        this.pushHistoryState('chat')
      }
    },
    // 处理页面切换动画，保持滚动位置
    onBeforeLeave(el) {
      // 保存当前滚动位置
      const scrollTop = el.scrollTop
      // 固定元素高度和位置，避免动画时跳动
      el.style.height = `${el.offsetHeight}px`
      el.style.overflow = 'hidden'
      // 将内容向上移动，模拟滚动效果
      const content = el.querySelector('.content')
      if (content) {
        content.style.transform = `translateY(-${scrollTop}px)`
      }
    },
    onAfterEnter(el) {
      // 动画结束后恢复滚动位置
      if (this.activeTab === 'home' && this.homeScrollPosition > 0) {
        el.scrollTop = this.homeScrollPosition
        console.log('动画结束，恢复滚动位置:', this.homeScrollPosition)
      }
    },
    logout() {
      if (confirm('确定退出登录吗？')) {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        window.location.href = '/'
        window.location.reload()
      }
    },
    openFengkongtu() {
      this.showFengkongtuPage = true
      this.pushHistoryState('fengkongtu')
    },
    openFukuantu() {
      this.showFukuantuPage = true
      this.pushHistoryState('fukuantu')
    },
    openPaymentPage() {
      this.showPaymentPage = true
      this.pushHistoryState('payment')
    },
    openSettingsPage() {
      this.showSettingsPage = true
      this.pushHistoryState('settings')
    },
    openRechargePage() {
      if (this.isGuest && !this.guestCanRecharge) {
        this.showInfoToast('主账号已禁止访客充值', 3000)
        return
      }
      this.showRechargePage = true
      this.pushHistoryState('recharge')
    },
    closeRechargePage() {
      this.showRechargePage = false
      // 关闭充值页面后刷新余额
      this.refreshUserInfo()
    },
    openRenewPage() {
      if (this.isGuest && !this.guestCanSpend) {
        this.showInfoToast('主账号已禁止访客花费余额', 3000)
        return
      }
      this.showRenewPage = true
      this.pushHistoryState('renew')
    },
    closeRenewPage() {
      this.showRenewPage = false
      // 关闭续费页面后刷新用户信息
      this.refreshUserInfo()
    },
    goToRechargeFromRenew() {
      this.showRenewPage = false
      this.showRechargePage = true
    },
    async openRecharge() {
      try {
        const res = await apiFetch('/api/settings/public/tg_username')
        if (res.code === 0 && res.data) {
          window.open(`https://t.me/${res.data}`, '_blank')
        } else {
          alert('充值功能暂未配置，请联系管理员')
        }
      } catch (e) {
        alert('充值功能暂时不可用')
      }
    },
    // 启动会话轮询
    startSessionPolling() {
      // 到期用户不需要轮询聊天会话
      if (this.isExpired) return

      // 先加载一次初始会话列表
      this.loadSessionsForNewUser(true)
      // 每2秒检查一次新会话
      this.sessionPollingInterval = setInterval(() => {
        // 如果用户已过期，停止轮询
        if (this.isExpired) {
          clearInterval(this.sessionPollingInterval)
          return
        }
        this.loadSessionsForNewUser(false)
      }, 2000)
    },
    // 加载会话列表检测新用户
    async loadSessionsForNewUser(isInitial) {
      try {
        const stored = localStorage.getItem('user')
        if (!stored) return
        const userData = JSON.parse(stored)
        const agentAccount = userData.account
        if (!agentAccount) return

        const response = await apiFetch(`/api/chat/sessions?agentAccount=${encodeURIComponent(agentAccount)}`)
        if (response.code === 0 && response.data) {
          const currentKeys = new Set(response.data.map(s => s.sessionKey))
          
          if (isInitial) {
            // 初始加载，只记录已有会话
            this.knownSessionKeys = currentKeys
          } else {
            // 检测新会话
            for (const session of response.data) {
              if (!this.knownSessionKeys.has(session.sessionKey)) {
                // 发现新会话，显示提示
                this.showNewUserNotification(session.customerName || session.sessionKey.split('_')[0])
                this.knownSessionKeys.add(session.sessionKey)
              }
            }
          }
        }
      } catch (e) {
        console.log('检测新用户失败:', e)
      }
    },
    // 显示新用户提示
    showNewUserNotification(userName) {
      this.toastMessage = `${userName} 新鱼加入!`
      this.toastType = 'newUser'
      this.showToast = true
      this.autoCloseToast(5000)
    },
    // 显示复制成功提示
    showCopyToast(message = '链接已复制') {
      this.toastMessage = message
      this.toastType = 'copy'
      this.showToast = true
      this.autoCloseToast(3000)
    },
    // 显示通用提示
    showInfoToast(message, duration = 3000) {
      this.toastMessage = message
      this.toastType = 'info'
      this.showToast = true
      this.autoCloseToast(duration)
    },
    // 自动关闭提示
    autoCloseToast(duration) {
      if (this.toastTimeout) clearTimeout(this.toastTimeout)
      this.toastTimeout = setTimeout(() => {
        this.showToast = false
      }, duration)
    },
    // 关闭提示
    closeToast() {
      this.showToast = false
      if (this.toastTimeout) clearTimeout(this.toastTimeout)
    },
    // 点击提示处理
    handleToastClick() {
      if (this.toastType === 'newUser' && this.canUseChat) {
        this.showToast = false
        this.switchTab('chat')
      }
    },
    // 打开分享页
    openSharePage() {
      this.showSharePage = true
      this.pushHistoryState('share')
    },
    closeSharePage() {
      this.showSharePage = false
      this.syncTabUrl(this.activeTab || 'home')
    },

    // ========== 返回键处理 ==========
    // 初始化历史状态
    initHistoryState() {
      // 替换当前状态为基础状态
      const page = this.showSharePage ? 'share' : (this.activeTab || 'home')
      const path = this.getConsolePath(page)
      history.replaceState({ page }, '', `${path}${window.location.search}`)
    },
    // 推入新的历史状态
    pushHistoryState(page) {
      const path = this.getConsolePath(page)
      history.pushState({ page }, '', `${path}${window.location.search}`)
    },
    getConsolePath(page) {
      if (page === 'chat') return '/console/chat'
      if (page === 'share') return '/console/share'
      return '/console/home'
    },
    // URL -> tab
    resolveTabFromPath() {
      const path = window.location.pathname || '/'
      return path.startsWith('/console/chat') ? 'chat' : 'home'
    },
    restoreViewFromPath() {
      const path = window.location.pathname || '/'
      if (path.startsWith('/console/share')) {
        this.activeTab = 'home'
        this.showSharePage = true
        return
      }
      this.activeTab = this.resolveTabFromPath()
      this.showSharePage = false
    },
    // tab -> URL（不刷新）
    syncTabUrl(tab) {
      const path = tab === 'chat' ? '/console/chat' : '/console/home'
      if (window.location.pathname === path) return
      history.replaceState({ page: tab }, '', `${path}${window.location.search}`)
    },
    // 处理返回事件
    handlePopState() {
      // 如果在聊天tab，先让聊天组件处理（关闭弹窗、返回会话列表等）
      if (this.activeTab === 'chat' && this.$refs.chatPage) {
        const handled = this.$refs.chatPage.handleBackPress()
        if (handled) {
          this.pushHistoryState('chat') // 重新推入状态
          return
        }
      }

      // 检查是否有弹窗打开，优先关闭弹窗
      if (this.showSharePage) {
        this.showSharePage = false
        this.pushHistoryState('home') // 重新推入状态防止再次返回退出
        return
      }
      if (this.showSettingsPage) {
        this.showSettingsPage = false
        this.pushHistoryState('home')
        return
      }
      if (this.showRechargePage) {
        this.showRechargePage = false
        this.pushHistoryState('home')
        return
      }
      if (this.showRenewPage) {
        this.showRenewPage = false
        this.pushHistoryState('home')
        return
      }
      if (this.showPaymentPage) {
        this.showPaymentPage = false
        this.pushHistoryState('home')
        return
      }
      if (this.showFukuantuPage) {
        this.showFukuantuPage = false
        this.pushHistoryState('home')
        return
      }
      if (this.showXufeiPage) {
        this.showXufeiPage = false
        this.pushHistoryState('home')
        return
      }
      if (this.showFengkongtuPage) {
        this.showFengkongtuPage = false
        this.pushHistoryState('home')
        return
      }

      // 如果在聊天tab，返回到首页tab
      if (this.activeTab === 'chat') {
        this.transitionName = 'slide-right'
        this.activeTab = 'home'
        this.syncTabUrl('home')
        this.pushHistoryState('home')
        // 恢复首页滚动位置
        this.$nextTick(() => {
          const homeContent = this.$el.querySelector('.main-content')
          if (homeContent) {
            homeContent.scrollTop = this.homeScrollPosition
            console.log('返回键恢复首页滚动位置:', this.homeScrollPosition)
          }
        })
        return
      }

      // 已经在首页了，再推一个状态防止退出应用
      this.pushHistoryState('home')
    }
  }
}
</script>


<style scoped>
.page-wrapper {
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  padding-top: env(safe-area-inset-top); /* iOS 顶部安全区域 */
  box-sizing: border-box;
}

.main-content {
  flex: 1;
  width: 100%;
  background-color: #f5f5f5;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 70px;
}

.main-content.chat-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 0 !important;
  background-color: #fff !important;
  overflow-y: hidden;
}

.content {
  padding: 20px 16px;
}

/* 顶部标题 */
.page-title {
  font-size: 28px;
  font-weight: 800;
  color: #333;
  margin-bottom: 20px;
  letter-spacing: 2px;
}

/* 用户信息卡片 */
.info-card {
  background: #fff;
  border-radius: 12px;
  padding: 0;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.18s ease;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row[style*="cursor"]:active,
.info-row[style*="cursor: pointer"]:active {
  background-color: #f7f7f7;
}

.info-row .arrow {
  transition: transform 0.2s ease;
}

.info-row:active .arrow {
  transform: translateX(2px);
}

.info-label {
  font-size: 15px;
  color: #666;
  width: 50px;
}

.info-value {
  font-size: 15px;
  color: #333;
  flex: 1;
}

.refresh-hint {
  font-size: 11px;
  color: #999;
  margin-right: 8px;
}

.admin-badge {
  font-size: 10px;
  color: #a06a00;
  background: linear-gradient(135deg, #fef3d6, #fde8b0);
  padding: 3px 10px;
  border-radius: 20px;
  margin-right: 8px;
  letter-spacing: 0.5px;
  font-weight: 500;
  border: 0.5px solid rgba(210, 160, 60, 0.25);
}

.guest-badge {
  font-size: 10px;
  color: #6b6b70;
  background: linear-gradient(135deg, #f2f2f4, #e8e8eb);
  padding: 3px 10px;
  border-radius: 20px;
  margin-right: 8px;
  letter-spacing: 0.5px;
  font-weight: 500;
  border: 0.5px solid rgba(0, 0, 0, 0.06);
}

.expire-days {
  font-size: 14px;
  padding: 2px 10px;
  border-radius: 4px;
  margin-right: 8px;
}

.expire-normal {
  color: #4caf50;
  background: #e8f5e9;
}

.expire-warning {
  color: #ff9800;
  background: #fff3e0;
}

.expire-critical {
  color: #ff5722;
  background: #fbe9e7;
}

.expire-expired {
  color: #f44336;
  background: #ffebee;
}

.arrow {
  font-size: 20px;
  color: #ccc;
}

/* TG频道提示 */
.tg-notice {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.tg-title {
  font-size: 15px;
  font-weight: 600;
  color: #d4a017;
  margin-bottom: 8px;
}

.tg-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

/* 功能按钮网格 */
.feature-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.feature-item {
  width: calc(50% - 8px);
  height: 72px;
  background: #fff;
  border-radius: 12px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  box-sizing: border-box;
  transition: transform 0.2s cubic-bezier(0.2, 0, 0, 1), background-color 0.18s ease, box-shadow 0.2s ease;
  will-change: transform;
}

.feature-item:hover {
  background: #fafafa;
}

.feature-item:active {
  transform: scale(0.97);
  background: #f5f5f5;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.feature-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-text {
  font-size: 15px;
  color: #333;
}

.disabled-feature {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

/* 底部导航栏 */
.custom-tabbar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(56px + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background: #fff;
  border-top: none;
  box-shadow: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 10;
}

.custom-tabbar .tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 1;
  padding: 4px 0;
  transition: opacity 0.15s ease;
}

.custom-tabbar .tab-item:active {
  opacity: 0.6;
}

.custom-tabbar .tab-text {
  margin-top: 3px;
  font-size: 12px;
  color: #707070;
  transition: color 0.2s ease;
}

.custom-tabbar .tab-item.active .tab-text {
  color: #007AFF;
}

.custom-tabbar .tab-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}


/* 滑动动画 */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-left-leave-active,
.slide-right-leave-active {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.slide-left-enter-from { transform: translateX(100%); }
.slide-left-enter-to { transform: translateX(0); }
.slide-left-leave-from { transform: translateX(0); }
.slide-left-leave-to { transform: translateX(-100%); }

.slide-right-enter-from { transform: translateX(-100%); }
.slide-right-enter-to { transform: translateX(0); }
.slide-right-leave-from { transform: translateX(0); }
.slide-right-leave-to { transform: translateX(100%); }

/* 全屏弹窗 */
.share-page-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: #fff;
}

/* 新用户提示样式 */
.new-user-toast {
  position: fixed;
  top: 10px;
  left: 10px;
  right: 10px;
  background: #4CAF50;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  z-index: 99999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  will-change: transform, opacity;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.toast-icon {
  width: 24px;
  height: 24px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.toast-text {
  flex: 1;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
}

.toast-close {
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  flex-shrink: 0;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.toast-close:hover {
  opacity: 1;
}

.toast-close:active {
  transform: scale(0.85);
}

/* 提示滑入动画 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-down-enter-from {
  transform: translateY(-100%) translateZ(0);
  opacity: 0;
}

.slide-down-enter-to {
  transform: translateY(0) translateZ(0);
  opacity: 1;
}

.slide-down-leave-from {
  transform: translateY(0) translateZ(0);
  opacity: 1;
}

.slide-down-leave-to {
  transform: translateY(-100%) translateZ(0);
  opacity: 0;
}

/* ========================================
   桌面端四栏布局
   ======================================== */

/* 桌面端 page-wrapper 变成横向 flex */
.page-wrapper.desktop-layout {
  flex-direction: row;
  overflow: hidden;
}

/* 第一栏：左侧导航栏（窄） */
.desktop-sidebar-nav {
  width: 68px;
  min-width: 68px;
  height: 100%;
  background: #fff;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0;
  gap: 4px;
  box-sizing: border-box;
  z-index: 20;
}

.nav-icon-item {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  transition: all 0.2s ease;
  gap: 2px;
}

.nav-icon-item:hover {
  color: #333;
  background: rgba(0, 0, 0, 0.04);
}

.nav-icon-item.active {
  color: #007AFF;
  background: rgba(0, 122, 255, 0.08);
}

.nav-icon-item.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.nav-icon-item.logout-nav {
  color: #ccc;
}

.nav-icon-item.logout-nav:hover {
  color: #ff4d4f;
  background: rgba(255, 77, 79, 0.06);
}

.nav-label {
  font-size: 10px;
  line-height: 1;
  margin-top: 1px;
}

.nav-spacer {
  flex: 1;
}

/* 桌面端主内容区（flex 占满剩余空间） */
.desktop-main-area {
  flex: 1;
  display: flex;
  height: 100%;
  overflow: hidden;
  min-width: 0;
}

/* 第二栏：主页仪表盘 或 对话列表 */
.desktop-panel-second {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 桌面端主页面板 */
.desktop-home-panel {
  width: 340px;
  min-width: 280px;
  max-width: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.desktop-home-header {
  padding: 16px 20px;
  font-size: 20px;
  font-weight: 700;
  color: #000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.desktop-home-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.desktop-home-scroll .info-card {
  margin-bottom: 16px;
}

.desktop-home-scroll .tg-notice {
  margin-bottom: 16px;
}

.desktop-home-scroll .feature-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.desktop-home-scroll .feature-item {
  width: calc(33.333% - 8px);
  height: auto;
  padding: 16px 12px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.desktop-home-scroll .feature-icon {
  margin-right: 0;
  margin-bottom: 8px;
}

/* 桌面端对话全区域（ChatPage 占满，内部自己管理列表+详情+话术三栏） */
.desktop-chat-full {
  flex: 1;
  height: 100%;
  display: flex;
  overflow: hidden;
}

/* 第三栏占位（当主页激活时） */
.desktop-panel-chat-placeholder {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  min-width: 0;
}

.placeholder-content {
  text-align: center;
  color: #999;
}

.placeholder-content p {
  margin-top: 16px;
  font-size: 15px;
}
</style>
